import React, { FormEvent, useRef } from "react";

interface ChatMessage {
  role: "user" | "model";
  text: string;
}

// interface ChatFormProps {
//   chatHistory: ChatMessage[];
//   setChatHistory: React.Dispatch<React.SetStateAction<ChatMessage[]>>;
//   generateBotResponse: (history: ChatMessage[]) => void;
// }
interface ChatFormProps {
  chatHistory: ChatMessage[];
  setChatHistory: React.Dispatch<React.SetStateAction<ChatMessage[]>>;
  generateBotResponse: (history: ChatMessage[]) => Promise<void>; // Allow async
}

const ChatForm: React.FC<ChatFormProps> = ({ chatHistory, setChatHistory, generateBotResponse }) => {
	const inputRef = useRef<HTMLInputElement | null>(null);

	const handleFormSubmit = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const userMessage = inputRef.current?.value.trim();
		if (!userMessage) return
		if (inputRef.current) { inputRef.current.value = "" }

		// Update chat history with the user's message
		setChatHistory((history) => [...history, { role: "user", text: userMessage }]);

		// Delay 600 ms before showing "Thinking..." and generating response
		setTimeout(() => {
			// Add a "Thinking..." placeholder for the bot's response
			setChatHistory((history) => [...history, { role: "model", text: "Thinking..." }]);

			// Call the function to generate the bot's response
			generateBotResponse([...chatHistory, { role: "user", text: `Using the details provided above, please address this query: ${userMessage}` }]); 
		}, 600);
	};

	return (
		<form onSubmit={handleFormSubmit} className="chat-form">
			<input ref={inputRef} placeholder="Message..." className="message-input" required />
			<button type="submit" id="send-message" className="material-symbols-rounded">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" color="#fff" fill="#fff" 
				style={{ marginTop: "4px", marginLeft: "1px" }}>
					<path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
				</svg>
			</button>
		</form>		
	);
};

export default ChatForm;